/**
 * SubscriberGrid.js
 * File cloned from account/AccountGrid.js and modified
 */
import Constants from "components/utils/constants";
const mux = (f) => Constants.agGridFieldDefFactor(f);
/**
 * 
 * @param {params object passed on to aggrid column def object} params 
 * @param {zoom factor; 1=smallest, 2=medium, 3=large, 4=extra large} factor 
 * @returns 
 */
let fieldType = (factor=1) => {
    return {
        headerName: '',
        field: 'type',
        width: 32 * mux(factor),
        cellStyle: {margin: "0px", padding: "0px"},
        cellRenderer: (params)=>{
            // let cell = params.value;
            // let name = typeMap[code];
            let icon = `<img 
                width="30px" 
                style="background: transparent;"
                src="assets/img/accounts/icons/SUB.png"
                alt="SUB" />`;
            // return `<a  key={account._id} href="/transactions/${params.data._id}">${icon}</a>`;
            return icon;
        }
    }
}
let fieldFirstName = (factor=1, props={style: {margin: "0px", padding: "0px"}}) => {
    let {style} = props;
    return {
        headerName: 'First Name',
        field: 'fname',
        // cellStyle: style,
        maxWidth: 70 * mux(factor),

    }
}
let fieldLastName = (factor=1, props={style: {margin: "0px", padding: "0px"}}) => {
    let {style} = props;
    return {
        headerName: 'Last Name',
        field: 'lname',
        // cellStyle: style,
        width: 70 * mux(factor)
    }
}
let fieldDescription = (factor=1) => {
    return {
        headerName: 'Description',
        field: 'desc',
        // width: 220 * mux(factor),
        flex: 1
    }
}
// let fieldCurrency = (factor=1) => {
//     return {
//         headerName: 'Curr',
//         field: 'curr',
//         cellStyle: {margin: "0px", padding: "0px"},
//         width: 60 * mux(factor)
//     }
// }
let fieldUpdated = (factor=1) => {
    return {
        headerName: 'Updated',
        field: 'updated_at',
        width: 80 * mux(factor),
        cellRenderer: (params) => {
            return Constants.timeAgo(params.value)
        }
    }
}
let fieldCell = (factor=1, props={mask: false})  => {
    return {
        headerName: 'Cell',
        field: 'cell',
        // cellStyle: {textAlign: "right", margin: '0px', padding: '0px'},
        width: 90 * mux(factor),
        cellRenderer: (params) => {
            return (props.mask) ? params.data.isd_code + "**" + params.value.substr(6)
                          : params.data.isd_code + params.value;
        }
    }
}
let fieldEmail = (factor=1)  => {
    return {
        headerName: 'Email',
        field: 'email',
        // cellStyle: {textAlign: "right"},
        // maxWidth: 104 * mux(factor),
        flex: 1
    }
}
let fieldRegion = (factor=1)  => {
    return {
        headerName: 'Region',
        field: 'region',
        cellStyle: {textAlign: "right"},
        width: 60 * mux(factor),
        cellRenderer: (params) => {
            return `${params.data.country}/${params.data.state}`;
        }
    }
}
let fieldSince = (factor=1)  => {
    return {
        headerName: 'Since',
        field: 'date',
        width: 92 * mux(factor),
        cellRenderer: (params) => {
            return params.value?.substr(0,10);
        }
    }
}

export const SubscriberGrid = (width) => {
    let definitions = {
        portable : [
            fieldType(),
            fieldFirstName(2),
            fieldLastName(2),
            fieldCell(1, {mask: true}),
            fieldEmail(1),
            // fieldSince(),
            //TODO: No.of active chitfunds
        ],
        mobile : [
            fieldType(),
            fieldFirstName(2),
            fieldLastName(),
            fieldCell(1, {mask: true}),
            fieldEmail(2),
            // fieldSince(),
            //TODO: No.of active chitfunds
        ],
        tablet: [
            fieldType(),
            fieldFirstName(2),
            fieldLastName(2),
            fieldCell(2),
            // fieldRegion(),
            // fieldCurrency(1),
            fieldSince(),
            fieldEmail(2),
            //TODO: No.of active chitfunds
        ],
        laptop : [
            fieldType(2),
            fieldFirstName(3,{style: {margin: "2px", padding: "4px"}}),
            fieldLastName(3,{style: {margin: "2px", padding: "4px"}}),
            fieldCell(2),
            fieldEmail(3),
            fieldRegion(2),
            // fieldCurrency(1),
            fieldSince(2),
            fieldDescription(1),
            fieldUpdated(2)
        ],
        wide : [
            fieldType(2),
            fieldFirstName(4,{style: {margin: "2px", padding: "4px"}}),
            fieldLastName(4,{style: {margin: "2px", padding: "4px"}}),
            fieldCell(3),
            fieldEmail(3),
            fieldRegion(2),
            // fieldCurrency(1),
            fieldSince(2),
            fieldUpdated(2),
            fieldDescription(3)
        ],
    }
    if  (width > 1440) {
        // monitor
        return definitions.wide
    }  else if (width > 1024) {
        // laptop
        return definitions.laptop
    }  else if (width > 440) {
        // tablet
        return definitions.tablet
    } else if (width > 400) {
        // mobile
        return definitions.mobile
    } else {
        // portable
        return definitions.portable
    }
}